/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certifikace`
};

const da_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certification`
};

const de_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Zertifizierung`
};

const en_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certification`
};

const es_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `certificación`
};

const fr_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certification`
};

const hu_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certification`
};

const it_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certificazione`
};

const nl_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certificering`
};

const pl_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certyfikacja`
};

const pt_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certificação`
};

const sv_attributes_certification = /** @type {(inputs: {}) => string} */ () => {
	return `Certifiering`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_certification = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_certification(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_certification", locale)
	if (locale === "cs") return cs_attributes_certification(inputs)
	if (locale === "da") return da_attributes_certification(inputs)
	if (locale === "de") return de_attributes_certification(inputs)
	if (locale === "en") return en_attributes_certification(inputs)
	if (locale === "es") return es_attributes_certification(inputs)
	if (locale === "fr") return fr_attributes_certification(inputs)
	if (locale === "hu") return hu_attributes_certification(inputs)
	if (locale === "it") return it_attributes_certification(inputs)
	if (locale === "nl") return nl_attributes_certification(inputs)
	if (locale === "pl") return pl_attributes_certification(inputs)
	if (locale === "pt") return pt_attributes_certification(inputs)
	return sv_attributes_certification(inputs)
};
export { attributes_certification as "attributes.certification" }